module.exports = __webpack_public_path__ + "img/new-folder-icon.40c310c8.svg";